import getActionsData from "./getActionsData";
export default function selectAction(game, w, policy, q, epislon = 0) {
    const { actions, encodings } = getActionsData(game);
    return actions[policy(game, encodings, w, q, epislon)];
}
